import { Card, CardBody, Flex, StyleProps } from '@chakra-ui/react';
import { Championnat } from '../championnat.types';
import { ChampionnatCard } from './ChampionnatCard';
import { BPC_CARD_WIDTH } from 'common/common.constants';

export default function ChampionnatList({
  championnats,
  flexWrap,
  ...restStyleProps
}: {
  championnats: Championnat[];
} & StyleProps) {
  const mustWrap = flexWrap === 'wrap';
  return (
    <Flex
      display={!mustWrap ? undefined : { base: 'block', md: 'flex' }}
      {...restStyleProps}
    >
      {championnats.length ? (
        <>
          {championnats
            .sort((champA, champB) => (champA.name < champB.name ? 1 : -1))
            .map((championnat) => (
              <ChampionnatCard
                key={championnat.id}
                border="1px"
                borderColor="gray.200"
                minWidth={
                  !mustWrap
                    ? BPC_CARD_WIDTH
                    : { base: 'unset', md: BPC_CARD_WIDTH }
                }
                maxWidth={
                  !mustWrap
                    ? BPC_CARD_WIDTH
                    : { base: 'unset', md: BPC_CARD_WIDTH }
                }
                m={4}
                championnat={championnat}
              />
            ))}
        </>
      ) : (
        <Card m={4}>
          <CardBody>Aucun championnat à afficher</CardBody>
        </Card>
      )}
    </Flex>
  );
}
